<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'
import { dateStrTodate } from '@/utils'

export default {
  name: 'UpLevelDayStat',
  props: {
    typ: {
      Type: String,
      default: 'user'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '通关人数'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '25%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis',
          position: function(point) {
            const x = point[0]
            const y = '10%'// 向下移动 20 像素
            return [x, y]
          },
          formatter: function(params) {
            var tooltipContent = ''
            params.forEach(function(item) {
              if (item.value > 0) {
                tooltipContent += item.seriesName + ' : ' + item.value + '<br/>'
              }
            })
            return tooltipContent
          }
        },
        series: []
      }
    },
    refresh(data) {
      const time = []
      const upLevelData = {}
      for (const i in data) {
        time.push(dateStrTodate(data[i].date))
        for (const k in data[i][this.typ]) {
          const uData = data[i][this.typ][k]
          if (upLevelData[k] === undefined) {
            upLevelData[k] = []
          }
          upLevelData[k].push(uData)
        }
      }
      for (const i in upLevelData) {
        const level = '等级' + i
        this.option.legend.data.push(level)
        const temp = {
          name: level,
          data: upLevelData[i],
          type: 'line',
          smooth: true,
          label: {
            show: true,
            position: 'top', // 标签显示在折线图顶部
            formatter: '{c}' // 显示数值
          },
          itemStyle: {
            barWidth: '50%'
          }
        }
        this.option.series.push(temp)
      }
      if (this.typ === 'time') {
        this.option.title.text = '通关时间'
      }

      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
